// export const BASE_URL = "http://localhost:3001/api"
export const BASE_URL = "https://api.safesw.app/api"